import { DvSnapshotGroup } from './snapshot-group.entity';
import { Expose } from 'class-transformer';
export class DvSnapshot {
  @Expose()
  applicationId: string;

  @Expose()
  dataGroup?: DvSnapshotGroup[];

  //TODO: Think about if we can embed the PDF on this page instead of snapshot
  // @Expose()
  // pdfLink?: string;

  //TODO: Hash the data (json) object (without dates) to detect differences
  //Only include the json object with fields that are relevant (no dates or updatedby data).
  // @Expose()
  // diffHash?: string;

  //TODO: Json data dump to compare if we're using PDF link (serialized).
  // @Expose()
  // dataSnapshot?: string;

  @Expose()
  created?: Date;
}
